import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './bigButton.css'

export const BigButton = props => {   
    return (
        <div className={"big-btn" + (props.disabled ? " disabled" : "") + (props.active ? " active" : "")}>
            <button type="button" disabled={props.disabled} onClick={props.onClick}>
                <div className="big-btn-step">
                    {props.step}
                </div>
                <div className="big-btn-content">
                    <div className="big-btn-sm-text">
                        <span>{props.disabled && props.disabledText && props.disabledText.length > 0 ? props.disabledText : props.text}</span>
                    </div>
                    <div className="big-btn-text">
                        <span>{props.verb}</span>
                    </div>
                </div>
                {props.icon && 
                    <div className="big-btn-icon">
                        {props.processing ?
                            <FontAwesomeIcon icon="spinner" pulse className="big-btn-processing"></FontAwesomeIcon>
                            :
                            <FontAwesomeIcon icon={props.icon} className={props.iconClassName}></FontAwesomeIcon>
                        }                        
                    </div>
                }
            </button>
        </div>
    );
}